// clipHooks.js - Custom hooks for clip management
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteClip,
  loadClip,
  reset,
  restoreClip,
  revertClip,
  trashClip,
  updateClipMetadata,
} from "./index";

/**
 * Hook for clip management functionality
 */

export const useClip = () => {
  const dispatch = useDispatch();
  const clipState = useSelector((state) => state.clip);

  // Delete a clip
  const handleDelete = useCallback(
    (clip) => {
      return dispatch(deleteClip(clip));
    },
    [dispatch]
  );

  // Load a clip by case and clip ID
  const handleLoad = useCallback(
    (caseId, clipId) => {
      return dispatch(loadClip({ caseId, clipId }));
    },
    [dispatch]
  );

  // Reset clip state
  const handleReset = useCallback(() => {
    return dispatch(reset());
  }, [dispatch]);

  // Restore a clip
  const handleRestore = useCallback(
    (clip) => {
      return dispatch(restoreClip(clip));
    },
    [dispatch]
  );

  // Revert a clip to its previous state
  const handleRevert = useCallback(
    (caseId, clipId, commitId) => {
      return dispatch(revertClip({ caseId, clipId, commitId }));
    },
    [dispatch]
  );

  // Trash a clip
  const handleTrash = useCallback(
    (clip) => {
      return dispatch(trashClip(clip));
    },
    [dispatch]
  );

  // Update clip metadata
  const handleUpdateMetadata = useCallback(
    (cur) => {
      return dispatch(updateClipMetadata(cur));
    },
    [dispatch]
  );

  return {
    // State
    clip: clipState.clip,
    isLoading: clipState.loading,
    isLoaded: clipState.loaded,
    isSaving: clipState.saving,

    // Actions
    deleteClip: handleDelete,
    loadClip: handleLoad,
    reset: handleReset,
    restoreClip: handleRestore,
    revertClip: handleRevert,
    trashClip: handleTrash,
    updateClipMetadata: handleUpdateMetadata,
  };
};
